<template>
  <div class="geek-lp">
    <div class="content">
      <div class="exp">大学生限定プログラミングスクール</div>
      <img class="img" src="@/assets/geeksalon.png" />
      <div class="exp-2">お申し込みはこちらから！</div>
      <button class="btn" @click="toLP">無料説明会</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toLP: function() {
      const url = "https://geek-salon.com/"
      window.open(url, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
.geek-lp {
  background: transparent linear-gradient(90deg, #ffac59 0%, #ffc859 100%);
  padding: 11px 10px;
  .content {
    border: 1px solid #ffffff;
    opacity: 1;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    .exp {
      color: #ffffff;
      font-size: 1rem;
      margin-top: 40px;
      margin-bottom: 10px;
    }

    .img {
      width: 50%;
      height: auto;
      margin-bottom: 70px;
    }

    .exp-2 {
      color: #ffffff;
      font-size: 1rem;
      margin-bottom: 10px;
    }

    .btn {
      position: relative;
      display: inline-block;
      margin-bottom: 40px;
      font-size: 1.5rem;
      padding: 0.5em 2em;
      color: #ffac59;
      background-color: #ffffff; /*色*/
      border-radius: 2em; /*角の丸み*/
      box-shadow: 0px 5px #683e00;
      outline: none;
      transition: all 200ms 0s ease;
    }

    .btn:hover {
      /*押したとき*/
      transform: translateY(5px);
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
    }

    .btn:focus {
      background-color: #f1d0a0;
    }
  }
}
</style>
